import setting from '@/setting'
import { batchSaveTableConfig, getTableConfig } from '@/api/common/config'
import formConfigs from '@/assets/config/form.json'
import { cloneDeep } from 'lodash'
import { useDbUtil } from './db'

/**
 * 设置表格配置参数
 * @param {Array} config 表格配置
 * @param {Array} originConfig 原始表格配置
 * @returns {Array} 表格配置
 */
const handleFormConfig = (config, originConfig) => {
  if (
    config.some(item => originConfig.findIndex(originItem => originItem.uId === item.uId) === -1) ||
    config.length !== originConfig.length
  ) {
    originConfig.forEach(item => {
      const target = config.find(childItem => item.uId === childItem.uId)
      if (target) {
        Object.keys(item).forEach(key => {
          if (target[key] !== undefined && target[key] !== null) {
            item[key] = target[key]
          }
        })
      }
    })
    return originConfig
  } else {
    return config
  }
}

export const useFormUtil = {
  /**
   * 保存表单配置
   * @param {string} type 表单类型
   * @param {Array} config 表单配置
   */
  async saveFormConfig(type, config) {
    try {
      useDbUtil.set(`${setting.name}-form-config-${type}`, JSON.stringify(config), true)
      await batchSaveTableConfig(type, config)
    } catch (error) {
      console.error(error)
    }
  },

  /**
   * 获取表单配置
   * @param {string} type 表单类型
   * @returns {Array} 表单配置
   */
  getFormConfig(type) {
    return cloneDeep(
      formConfigs[type].map(item => ({
        uId: item[0] || '',
        name: item[1] || '',
        hide: item[2] || 0
      }))
    )
  },

  /**
   * 从缓存中获取表单配置
   * @param {string} type 表单类型
   * @param {Array} originConfig 原始表单配置
   * @returns {Array} 表单配置
   */
  getFormConfigCookie(type, originConfig) {
    const cookieConfig = useDbUtil.get(`${setting.name}-form-config-${type}`, '[]', true)
    const config = cookieConfig ? JSON.parse(cookieConfig) : []
    return handleFormConfig(config, originConfig)
  },

  /**
   * 请求表格配置
   * @param {string} type 表单类型
   * @param {Array} originConfig 原始表单配置
   * @returns {Promise} 表单配置
   */
  requestFormConfig(type, originConfig) {
    return new Promise((resolve, reject) => {
      getTableConfig(type)
        .then(res => {
          if (res.returnData && res.returnData.length > 0) {
            const config = handleFormConfig(res.returnData, originConfig)
            useDbUtil.set(`${setting.name}-form-config-${type}`, JSON.stringify(config), true)
            resolve(config)
          } else {
            reject(new Error('暂无表单配置'))
          }
        })
        .catch(error => reject(error))
    })
  },

  /**
   * 过滤表单配置参数
   * @param {Array} config 表单配置
   * @returns {Array} 表单配置
   */
  filterFormConfigParams(config, isHide = false) {
    return config.filter(item => (isHide ? item.hide === 1 : item.hide === 0))
  }
}
